import { CustomElement } from '@aurelia/runtime-html';
import "./page-header.scss";
export const name = "page-header";
export const template = "<div class=\"page-header\">\n  <h3>${title}</h3>\n</div>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
